// extracted by mini-css-extract-plugin
module.exports = {"info-page":"InfoPage_info-page__2QUf_","info-text":"InfoPage_info-text__1IcGm"};